var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2114_2498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.66666H12C12.3667 8.66666 12.6667 8.36666 12.6667 7.99999C12.6667 7.63332 12.3667 7.33332 12 7.33332H4C3.63333 7.33332 3.33333 7.63332 3.33333 7.99999C3.33333 8.36666 3.63333 8.66666 4 8.66666ZM2.66667 11.3333H10.6667C11.0333 11.3333 11.3333 11.0333 11.3333 10.6667C11.3333 10.3 11.0333 9.99999 10.6667 9.99999H2.66667C2.3 9.99999 2 10.3 2 10.6667C2 11.0333 2.3 11.3333 2.66667 11.3333ZM4.66667 5.33332C4.66667 5.69999 4.96667 5.99999 5.33333 5.99999H13.3333C13.7 5.99999 14 5.69999 14 5.33332C14 4.96666 13.7 4.66666 13.3333 4.66666H5.33333C4.96667 4.66666 4.66667 4.96666 4.66667 5.33332Z",
    fill: "#0094FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2114_2498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.9059e83ff224c5b0e56c64a357942bf2.svg";
export { ForwardRef as ReactComponent };